<template>

  <div id="post-vo">

    <!--            Informations principales -->
    <div v-show="currentTab === 'main'">
      <ubi-panel>
        <ubi-form-group :title="$t('posts.myAd')">
          <span slot="description" v-if="post.id" v-html="$t('posts.edit.e²itPostNonEditablesFieldsVo')"></span>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item :label="$t('posts.edit.reference')" prop="reference">
                <el-tooltip class="item" effect="dark"
                            :content="$t('posts.edit.tooltipReference')"
                            placement="bottom">
                  <el-input v-model="post.reference" :disabled="!create"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item>
                <el-radio-group v-model="typeOffreSelectVo"
                                @change="$emit('change_financement_type', typeOffreSelectVo)">
                  <el-radio label="null">{{ $t('posts.edit.achat') }}</el-radio>
                  <el-radio label="LLD">{{ $t('posts.edit.lld') }}</el-radio>
                  <el-radio label="LOA">{{ $t('posts.edit.loa') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12" v-if="typeOffreSelectVo !== 'null'">
              <el-form-item :label="$t('posts.edit.loyerMontantVo') + ' *'" prop="financement_mensualites">
                <el-input autocomplete="off" v-model.number="post.financement_mensualites">
                  <div slot="append">{{ getDevise }}</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" v-if="typeOffreSelectVo !== 'null'">
              &nbsp;
            </el-col>
            <el-col :span="10" v-if="typeOffreSelectVo !== 'null'">
              <el-form-item :label="$t('posts.edit.dureeLocationLoa')">
                <el-input autocomplete="off" v-model.number="post.financement_duree">
                  <div slot="append" style="text-transform: capitalize">{{ $t('general.month') }}</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="typeOffreSelectVo !== 'null'">
              <el-form-item :label="$t('posts.edit.kilometrageMaxLoa')">
                <el-input autocomplete="off" v-model.number="post.financement_kilometrage_max">
                  <div slot="append">KM</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="typeOffreSelectVo !== 'null'">
              <el-form-item :label="$t('posts.edit.financementApport')">
                <el-input autocomplete="off" v-model.number="post.financement_apport">
                  <div slot="append">{{ getDevise }}</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="typeOffreSelectVo !== 'null'">
              <el-form-item :label="$t('posts.edit.servicesInclusLoyer')">
                <el-input :rows="5" type="textarea" v-model="post.financement_services_inclus">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="typeOffreSelectVo !== 'null'">
              <el-form-item :label="$t('posts.edit.urlMentionsLegalesLoa')">
                <el-input autocomplete="off" v-model="post.financement_url_mentions_legales">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="typeOffreSelectVo === 'null'">
              <el-form-item :label="$t('posts.edit.priceIncludingVAT') + ' *'" prop="prix">
                <el-input autocomplete="off" v-model.number="post.prix">
                  <div slot="append">{{ getDevise }}</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="typeOffreSelectVo === 'null'">
              <el-form-item :label="$t('posts.edit.priceExcludingVAT')">
                <el-input autocomplete="off" v-model.number="post.prix_hors_taxe">
                  <div slot="append">{{ getDevise }}</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10" v-if="typeOffreSelectVo === 'null'">
              <el-form-item :label="$labels.prix_catalogue">
                <el-input autocomplete="off" v-model.number="post.prix_catalogue">
                  <div slot="append">{{ getDevise }}</div>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4" v-if="typeOffreSelectVo === 'null'">
              <el-form-item :label="$labels.devise_iso_4217">
                <el-select
                    v-model="post.devise_iso_4217"
                    @change="deviseSelect(post.devise_iso_4217)"
                    :value="valueDevise"
                    filterable
                    default-first-option
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="deviseChoice in this.getChoices('devise_iso_4217')"
                      :key="deviseChoice"
                      :label="deviseChoice"
                      :value="deviseChoice"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$labels.numero_serie" prop="numero_serie">
                <el-input v-model="post.numero_serie"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="typeOffreSelectVo === 'null'">
            <el-col :span="12">
              <el-form-item label=" ">
                <el-checkbox v-model="post.vehicule_import" true-label="oui" false-label="non">
                  {{ $labels.vehicule_import }}
                  <el-tooltip placement="top-start">
                    <div slot="content" v-html="$t('posts.edit.vehiculeImporte')"/>
                    <em class="el-icon-question" style="color: #255662"></em>
                  </el-tooltip>
                </el-checkbox>

              </el-form-item>
            </el-col>
            <el-col :span="12"
                    v-if="post.vehicule_import == 'non' || post.vehicule_import == null || post.vehicule_import == undefined">
              <el-form-item :label="$labels.numero_immatriculation" prop="numero_immatriculation">
                <el-input v-model="post.numero_immatriculation"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-else-if="post.vehicule_import == 'oui'">
              <el-form-item :label="$labels.numero_immatriculation">
                <el-input v-model="post.numero_immatriculation"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-col>
            <hr>
          </el-col>
          <el-row>
            <PostFormObjectType :post="post" :label="$t('posts.edit.vehicleType')"
                                @typeChange="loadBrands"
                                :desactiverChamp="desactiverChamp"></PostFormObjectType>
          </el-row>
          <el-row>
            <hr>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$labels.marque + ' *'" prop="marque" :key="componentKey" v-if="!estCampingCar">
                <el-select
                    v-model="post.marque"
                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                    clearable
                    filterable
                    @change="loadModels()"
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="marqueChoice in this.brands"
                      :key="marqueChoice"
                      :label="marqueChoice"
                      :value="marqueChoice"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <div v-if="!estMoto && !estCampingCar">
              <el-col :span="12">
                <el-form-item :label="$labels.modele + ' *'" prop="modele" :key="componentKey">
                  <el-select
                      v-model="post.modele"
                      :placeholder="$t('posts.edit.selectTypePlaceholder')"
                      clearable
                      filterable
                      @change="onModelChange()"
                  >
                    <el-option
                        style="text-transform:capitalize"
                        v-for="modeleChoice in this.models"
                        :key="modeleChoice"
                        :label="modeleChoice"
                        :value="modeleChoice"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </div>
            <!-- Affichage dans le cadre d'un deux roues-->
            <div v-if="estMoto">
              <el-col :span="12">
                <!-- Affichage dans le cadre d'une moto -->
                <el-form-item :label="$labels.modele + ' *'" v-if="post.typeObjet >= 13400" prop="modele_autre">
                  <el-input v-model="post.modele_autre"></el-input>
                </el-form-item>
                <el-form-item :label="$labels.modele" v-else prop="modele_autre">
                  <el-input v-model="post.modele_autre"></el-input>
                </el-form-item>
              </el-col>
            </div>
            <!-- Affichage dans le cas d'un camping car-->
            <div v-if="estCampingCar">
              <el-col :span="12">
                <el-form-item :label="$labels.marque" :key="componentKey">
                  <el-select
                      v-model="post.marque"
                      :placeholder="$t('posts.edit.selectTypePlaceholder')"
                      clearable
                      filterable
                      @change="loadModels()"
                  >
                    <el-option
                        style="text-transform:capitalize"
                        v-for="marqueChoice in this.brands"
                        :key="marqueChoice"
                        :label="marqueChoice"
                        :value="marqueChoice"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$labels.modele" :key="componentKey">
                  <el-select
                      v-model="post.modele"
                      :placeholder="$t('posts.edit.selectTypePlaceholder')"
                      clearable
                      filterable
                      @change="onModelChange()"
                  >
                    <el-option
                        style="text-transform:capitalize"
                        v-for="modeleChoice in this.models"
                        :key="modeleChoice"
                        :label="modeleChoice"
                        :value="modeleChoice"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$labels.marque_autre" key="componentKey">
                  <el-input v-model="post.marque_autre"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$labels.modele_autre" :key="componentKey">
                  <el-input v-model="post.modele_autre"></el-input>
                </el-form-item>
              </el-col>
            </div>
            <div v-if="!estMoto && !estCampingCar">
              <el-col :span="16">
                <el-form-item :label="$labels.version + ' *'" prop="version">
                  <el-input v-model="post.version"></el-input>
                </el-form-item>
              </el-col>
            </div>
            <div v-if="estMoto || estCampingCar">
              <el-col :span="16">
                <el-form-item :label="$labels.version">
                  <el-input v-model="post.version"></el-input>
                </el-form-item>
              </el-col>
            </div>
            <el-col :span="8">
              <el-form-item :label="$labels.millesime + ' *'" prop="millesime">
                <el-input v-model="post.millesime"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <hr>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item prop="kilometrage">
                <template #label>
                  {{$labels.kilometrage + ' *'}}
                  <el-tooltip v-if="post.statut === 'vehicule neuf'" placement="top-start" :content="$t('posts.edit.kilometrageAutomatic')"><em class="el-icon-question"></em>
                  </el-tooltip>
                </template>
                <el-input v-model.number="post.kilometrage">
                  <template slot="append">km</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label=" " class="checkbox_align">
                <el-checkbox v-model="post.kilometrage_garanti" true-label="oui" false-label="non">
                  {{ $labels.kilometrage_garanti }}
                </el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item :label="$labels.mise_en_circulation">
                <el-date-picker
                    v-model="post.mise_en_circulation"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy"
                    style="width: 200px;">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$labels.energie + ' *'" prop="energie"
                            v-if="this.post.typeObjet >= 13000 && this.post.typeObjet <= 13590">
                <el-radio-group v-model="post.energie">
                  <el-radio label="essence">{{ $t('posts.edit.fuel') }}</el-radio>
                  <el-radio label="électrique">{{ $t('posts.edit.electric') }}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item :label="$labels.energie + ' *'" prop="energie" v-else>
                <el-select
                    v-model="post.energie"
                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                    clearable
                    filterable
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="energieChoice in this.getChoices('energie')"
                      :key="energieChoice"
                      :label="energieChoice"
                      :value="energieChoice"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('posts.edit.typeTransmission')"
                            v-if="this.post.typeObjet >= 13000 && this.post.typeObjet < 14000">
                <el-select
                    v-model="post.vehicule_distribution_type"
                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                    clearable
                    filterable
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="distributionChoice in this.getChoices('vehicule_distribution_type')"
                      :key="distributionChoice"
                      :label="distributionChoice"
                      :value="distributionChoice"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$labels.vehicule_distribution_type" v-else>
                <el-select
                    v-model="post.vehicule_distribution_type"
                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                    clearable
                    filterable
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="distributionChoice in this.getChoices('vehicule_distribution_type')"
                      :key="distributionChoice"
                      :label="distributionChoice"
                      :value="distributionChoice"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$labels.nb_places">
                <el-input v-model.number="post.nb_places">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$labels.nb_portes">
                <el-input v-model.number="post.nb_portes">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <div style="font-size: 12px;">{{ $labels.boite_de_vitesse }}
                  <el-button class="el-icon-error reset-radio"
                             v-if="post.boite_de_vitesse != '' && post.boite_de_vitesse != undefined && post.boite_de_vitesse != null"
                             @click="post.boite_de_vitesse = null"
                             circle></el-button>
                </div>
                <el-radio-group v-model="post.boite_de_vitesse">
                  <el-radio
                      v-for="boite_de_vitesseChoice in this.getChoices('boite_de_vitesse')"
                      :label="boite_de_vitesseChoice"
                      :value="boite_de_vitesseChoice">
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col>
              <hr>
            </el-col>
            <el-col :span="24">
              <el-form-item v-if="this.post.typeObjet < 13000 || this.post.typeObjet > 13590">
                <div style="font-size: 12px;">{{ $labels.roues_motrices }}
                  <el-button class="el-icon-error reset-radio"
                             v-if="post.roues_motrices != '' && post.roues_motrices != undefined && post.roues_motrices != null"
                             @click="post.roues_motrices = null"
                             circle></el-button>
                </div>
                <el-radio-group v-model="post.roues_motrices">
                  <!--                                    &lt;!&ndash; There is a problem with this radio because the value is not correctly reloaded &ndash;&gt;-->
                  <!--                                    &lt;!&ndash; when editing the ad &ndash;&gt;-->
                  <!--                                    <el-radio-->
                  <!--                                            v-for="rouesMotricesChoice in this.getChoices('roues_motrices')"-->
                  <!--                                            :label="rouesMotricesChoice"-->
                  <!--                                            :value="rouesMotricesChoice">-->
                  <!--                                    </el-radio>-->
                  <el-radio label="2"></el-radio>
                  <el-radio label="4"></el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$labels.puissance_reelle">
                <el-input v-model="post.puissance_reelle">
                  <template slot="append">CH</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$labels.puissance_fiscale">
                <el-input v-model="post.puissance_fiscale">
                  <template slot="append">CV</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$labels.nb_rapports">
                <el-input v-model.number="post.nb_rapports">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$labels.emission_co2">
                <el-input v-model="post.emission_co2">
                  <template slot="append">g/km</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$labels.classe_emission_co2">
                <el-select v-model="post.classe_emission_co2">
                  <el-option key='A' value='A'>A : émissions inférieures ou égales à 100 g/CO2/km.</el-option>
                  <el-option key='B' value='B'>B : de 101 à 120 g/CO2/km.</el-option>
                  <el-option key='C' value='C'>C : de 121 à 140 g/CO2/km.</el-option>
                  <el-option key='D' value='D'>D : de 141 à 160 g/CO2/km.</el-option>
                  <el-option key='E' value='E'>E : de 161 à 200 g/CO2/km.</el-option>
                  <el-option key='F' value='F'>F : de 201 à 250 g/CO2/km.</el-option>
                  <el-option key='G' value='G'>G : supérieures à 250 g/CO2/km.</el-option>
                </el-select>
                <!--                                <el-input v-model="post.classe_emission_co2">-->
                <!--                                    <template slot="append">g/km</template>-->
                <!--                                </el-input>-->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Crit'Air">
                <el-input v-model="post.classe_critair">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$labels.poids">
                <el-input v-model="post.poids">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="25">
            <el-col :span="12">
              <el-form-item v-if="isMotoOrQuadNoElectric" :label="$labels.cylindree +' *'" prop="cylindree"
                            style="font-weight: bold">
                <el-input v-model="post.cylindree">
                  <template slot="append">cm3</template>
                </el-input>
              </el-form-item>
              <el-form-item v-else :label="$labels.cylindree" prop="cylindree">
                <el-input v-model="post.cylindree">
                  <template slot="append">cm3</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$labels.nb_cylindres">
                <el-input v-model.number="post.nb_cylindres">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$labels.couleur">
                <el-select
                    v-model="post.couleur"
                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                    clearable
                    filterable
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="couleurChoice in this.getChoices('couleur')"
                      :key="couleurChoice"
                      :label="couleurChoice"
                      :value="couleurChoice"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$labels.couleur_precision">
                <el-select
                    v-model="post.couleur_precision"
                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                    clearable
                    filterable
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="couleur_precisionChoice in this.getChoices('couleur_precision')"
                      :key="couleur_precisionChoice"
                      :label="couleur_precisionChoice"
                      :value="couleur_precisionChoice"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$labels.interieur">
                <el-select
                    v-model="post.interieur"
                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                    clearable
                    filterable
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="interieurChoice in this.getChoices('interieur')"
                      :key="interieurChoice"
                      :label="interieurChoice"
                      :value="interieurChoice"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$labels.interieur_couleur">
                <el-select
                    v-model="post.interieur_couleur"
                    :placeholder="$t('posts.edit.selectTypePlaceholder')"
                    clearable
                    filterable
                >
                  <el-option
                      style="text-transform:capitalize"
                      v-for="interieurCouleurChoice in this.getChoices('interieur_couleur')"
                      :key="interieurCouleurChoice"
                      :label="interieurCouleurChoice"
                      :value="interieurCouleurChoice"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item
                  :label="$t('posts.urlAnnonceSiteAnnonceur')"
                  prop="url_annonce_sur_site_annonceur"
              >
                <el-input type="url_annonce_sur_site_annonceur" v-model="post.url_annonce_sur_site_annonceur">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="commentaire_public_vo">
                <span style="line-height: 1.5; font-weight: bolder;">{{ $t('posts.informationsComplementaires') }}</span>
                <el-tooltip placement="top-start">
                  <div slot="content" v-html="$t('posts.edit.informationsComplementaires')"/>
                  <em class="el-icon-question" style="color: #255662"></em>
                </el-tooltip>
                <el-input type="textarea" v-model="post.commentaire_public_vo"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </ubi-form-group>
      </ubi-panel>
      <ubi-panel>
        <ubi-form-group :title="$t('posts.vehicleDescription')">
          <template v-slot:description>
            {{ $t('posts.edit.vehicleDescriptionLBC') }}
          </template>
          <el-row>
            <el-col :lg="24">
              <el-form-item :label="$labels.public_comments_leboncoin">
                <el-input :rows="5" type="textarea" v-model="post.public_comments_leboncoin"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </ubi-form-group>
      </ubi-panel>
      <ubi-panel>
        <ubi-form-group :title="$t('posts.saleConditionsTitle')">
          <el-row>
            <el-col :span="24">
              <el-form-item>
                <div style="font-size: 12px;">{{ $labels.etat }}
                  <el-button class="el-icon-error reset-radio"
                             v-if="post.etat_produit != '' && post.etat_produit != undefined && post.etat_produit != null"
                             @click="post.etat_produit = null"
                             circle></el-button>
                </div>
                <el-radio-group v-model="post.etat_produit">
                  <el-radio
                      v-for="etatChoice in this.getChoices('etat')"
                      :label="etatChoice"
                      :value="etatChoice">
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <hr>
          </el-row>
          <el-row>
            <el-col :span="24">
              {{ $t('posts.edit.warranty') }}
            </el-col>
            <el-col :span="6">
              <el-form-item label=" ">
                <el-checkbox v-model="post.premiere_main" true-label="oui" false-label="non">Première
                  main
                </el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-form-item :label="$labels.garantie_libelle">
                <el-input v-model="post.garantie_libelle"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$labels.garantie_date_limite">
                <el-date-picker
                    v-model="post.garantie_date_limite"
                    format="dd/MM/yyyy"
                    value-format="dd/MM/yyyy">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$labels.garantie">
                <el-input v-model="post.garantie">
                  <template slot="append">{{ $t('general.month') }}</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <hr>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item :label="$labels.prix_marchand">
                <el-input v-model="post.prix_marchand">
                  <template slot="append">{{ getDevise }}</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label=" " class="checkbox_align">
                <el-checkbox v-model="post.tva_recuperable" true-label="oui" false-label="non">
                  {{ $labels.tva_recuperable }}
                </el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$labels.taux_tva">
                <el-input v-model="post.taux_tva">
                  <template slot="append">%</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <hr>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item>
                <div style="font-size: 12px;">{{ $labels.statut }}
                  <el-button class="el-icon-error reset-radio"
                             v-if="post.statut !== '' && post.statut !== undefined && post.statut != null"
                             @click="post.statut = null"
                             circle></el-button>
                </div>
                <el-radio-group v-model="post.statut">
                  <el-radio
                      v-for="statutChoice in this.getChoices('statut')"
                      :label="statutChoice"
                      :value="statutChoice"
                      style="margin-right: 25px;">
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <hr>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label=" ">
                {{ $t('posts.edit.locationToPublishTitle') }}
                <el-tooltip placement="top-start">
                  <div slot="content" v-html="$t('posts.edit.locationToPublishTooltipVo')"/>
                  <em class="el-icon-question"></em>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$labels.code_postal" prop="code_postal">
                <el-autocomplete
                    class="inline-input"
                    v-model="post.code_postal"
                    :fetch-suggestions="searchPostal"
                    @select="selectPostal"></el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$labels.ville" prop="ville">
                <el-input v-model="post.ville"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </ubi-form-group>
      </ubi-panel>

      <ubi-panel>
        <PostFormContactInfo :post="post" :id-user="idUser"/>
      </ubi-panel>
      <PostFormAttachedUser :post="post" :id-user="idUser"/>
    </div>

    <div v-show="currentTab === 'equipment'">
      <ubi-panel>
        <PostEditVoEquipements :post.sync="post"/>
      </ubi-panel>
    </div>

    <div v-show="currentTab === 'medias'">
      <ubi-panel>
        <PostFormGroupPhotos/>
        <PostImagesUpload :post="post" :desactiverChamp="desactiverChamp"/>
      </ubi-panel>

      <PostOtherMediaUpload :post="post" :desactiverChamp="desactiverChamp"/>
    </div>

    <div v-show="currentTab === 'international'">
      <ubi-panel>
        <ubi-form-group :title="$t('posts.edit.internationalTitle')">
          <el-col :span="24">
            <el-form-item :label="$labels.titre_anglais">
              <el-input v-model="post.titre_anglais" :disabled="desactiverChamp"/>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item :label="$labels.texte_anglais">
              <el-input :rows="5" type="textarea" v-model="post.texte_anglais"
                        :disabled="desactiverChamp"/>
            </el-form-item>
          </el-col>
        </ubi-form-group>
      </ubi-panel>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import {
  getDefinitionDonneeListeeByCode,
  getPostById,
  duplicateFromParent,
  getModelsOfBrand,
  getBrandsOfObjectType
} from '@/services/posts'

import UbiPanel from '@/components/Panel'
import UbiCardContainer from '@/components/CardContainer'
import UbiCard from '@/components/Card'
import PostFormObjectType from '../components/PostFormObjectType'
import PostFormOfferType from '../components/PostFormOfferType'
import PostFormContactInfo from '../components/PostFormContactInfo'
import PostFormGroupPhotos from '../components/PostFormGroupPhotos'
import PostImagesUpload from '../components/PostImagesUpload'
import PostEditVoEquipements from '../forms/vo/PostEditVoEquipements'
import PostFormAttachedUser from '../components/PostFormAttachedUser'
import PostOtherMediaUpload from '../components/PostOtherMediaUpload'

// SomeComponent.vue
import { createHelpers } from 'vuex-map-fields'
import { getCodePostalVille } from '../../../services/toolbox'

// `fooModule` is the name of the Vuex module.
const { mapFields } = createHelpers({
  getterType: 'posts/getPostField',
  mutationType: 'posts/updatePostField'
})

export default {
  name: 'PostEditVo',
  props: ['currentTab', 'create', 'post', 'idUser'],
  watch: {
    typeObjet: {
      handler () {
        this.loadBrands(false)
        this.loadModels(false)
        this.controleTypeObjet()
      },
      deep: true,
      immediate: true
    }
  },

  components: {
    PostEditVoEquipements,
    PostImagesUpload,
    PostFormGroupPhotos,
    PostFormOfferType,
    PostFormObjectType,
    PostFormContactInfo,
    UbiCard,
    UbiCardContainer,
    UbiPanel,
    PostFormAttachedUser,
    PostOtherMediaUpload
  },
  inject: ['browserContext'],

  data () {
    return {
      ddList: [],
      brands: [],
      models: [],
      tabs: [
        {
          name: 'main',
          title: this.$t('posts.edit.tabMain')
        },
        {
          name: 'equipment',
          title: this.$t('posts.edit.tabEquipments')
        },
        {
          name: 'medias',
          title: this.$t('posts.edit.tabMedias')
        },
        {
          name: 'international',
          title: this.$t('posts.edit.tabInternational')
        }
      ],
      // used to re-render the component to update the el-select of models
      // to solve this problem: the value is not updated when creating an ad.
      componentKey: 0,
      desactiverChamp: false,
      estMoto: false,
      estCampingCar: false,
      chargementEditEnd: false,
      valueDevise: '',
      typeOffreSelectVo: 'null'
    }
  },
  // watch: {
  //     post() {
  //         this.loadBrands(false);
  //         this.loadModelsloadModels(false);
  //     }
  // },
  methods: {
    ...mapMutations('posts', [
      'setOfferType',
      'setObjectType',
      'setTabs'
    ]),
    getChoices (code) {
      if (!this.ddList.length) return []
      const dd = this.ddList.find(x => x.code === code.toUpperCase())
      if (dd) {
        return dd.values
      }
      return []
    },
    async loadBrands (resetInput = true) {
      this.$emit('change-object-type-auto', this.post.typeObjet)
      if (this.post.typeObjet == null) {
        this.post.marque = ''
        this.models = []
        this.post.modele = ''
        this.brands = []
      } else {
        const brands = await getBrandsOfObjectType(this.post.typeObjet, false)
        if (brands.type == 'error') {
          // this.$message({message: this.$t("error.found"), type: 'error'});
          this.loading = false
          return false
        }
        if (resetInput) {
          this.post.marque = ''
          this.models = []
          this.post.modele = ''
        }
        this.brands = brands
        this.controleTypeObjet()
      }
    },
    selectPostal (item) {
      this.post.ville = item.ville
      this.post.code_postal = item.code_postal
    },
    async searchPostal (queryString, cb) {
      const results = await getCodePostalVille(queryString, this.post.pays)
      if (results.type == 'error') {
        // this.$message({message: this.$t("error.found"), type: 'error'});
        this.loading = false
        return false
      }
      const tab = Object.values(results.result)
      cb(tab)
    },
    controleTypeObjet () {
      if (this.post.typeObjet && this.post.typeObjet.length == undefined) {
        if (this.post.typeObjet >= 13000 && this.post.typeObjet <= 13590) {
          this.estMoto = true
          this.estCampingCar = false
        } else if (this.post.typeObjet >= 15000 && this.post.typeObjet <= 15300) {
          this.estMoto = false
          this.estCampingCar = true
        } else {
          this.estMoto = false
          this.estCampingCar = false
        }
      }
    },
    async loadModels (resetInput = true) {
      if (!this.post.marque) {
        this.models = []
        this.post.modele = ''
        return
      }

      if (!this.estMoto) {
        const models = await getModelsOfBrand(this.post.marque)
        if (models.type == 'error') {
          // this.$message({message: this.$t("error.found"), type: 'error'});
          this.loading = false
          return false
        }
        if (resetInput) {
          this.post.modele = ''
        }
        this.models = Object.values(models)
      } else {
        this.onModelChange()
      }
    },
    onModelChange () {
      this.componentKey += 1
    },
    aDesactiver () {
      if (this.create) {
        this.desactiverChamp = false
      } else if (this.getSitimmoUser.saisit_en_ligne_et_flux && this.$route.query.saisie !== 'SAISIE_VO') {
        this.desactiverChamp = true
      } else {
        this.desactiverChamp = false
      }
    },
    deviseSelect (value) {
      this.valueDevise = value
      this.$store.commit('donnees/SET_DEVISE', this.post.devise_iso_4217)
      return value
    }
  },
  computed: {
    ...mapGetters('posts', [
      'getOfferType', 'getObjectType'
    ]),
    ...mapGetters(['getSitimmoUser']),
    // TODO do the same things than postEditImmo instead of mapfields
    ...mapFields([
      'reference',
      'prix',
      'titre',
      'afficher_prix',
      'text',
      'pays',
      'communiquer_adresse_exacte',
      'code_postal_reel',
      'ville_reelle',
      'nom_voie',
      'numero_voie',
      'adresse2',
      'code_postal',
      'ville',
      'prix_vendu_net',
      'surface_habitable'
    ]),
    typeObjet () {
      this.controleTypeObjet()
      return this.post.typeObjet
    },
    isMotoOrQuadNoElectric () {
      const electric = this.post.energie === 'électrique' || this.post.energie === 'eléctrico' ||
          this.post.energie === 'electric'
      return (this.post.typeObjet >= 13400 || this.post.typeObjet >= 14000) && !electric
    },
    getDevise () {
      return this.$store.getters['donnees/getDevise']
    }
  },
  async beforeMount () {
    this.post.typeOffre = 'O'
    this.setTabs(this.tabs)
    let codes = [
      'boite_de_vitesse',
      'energie',
      'couleur',
      'couleur_precision',
      'interieur',
      'interieur_couleur',
      'etat',
      'statut',
      'roues_motrices',
      'devise_iso_4217',
      'vehicule_distribution_type',
      'type_document_1'
    ]
    codes = codes.map(function (x) {
      return x.toUpperCase()
    })
    this.ddList = await getDefinitionDonneeListeeByCode({ codes: codes })
  },
  mounted () {
    if (this.post.typeObjet == undefined) {
      this.post.typeObjet = null
    }
    if (!this.post.devise_iso_4217) {
      this.post.devise_iso_4217 = 'EUR'
    }
    this.aDesactiver()
  }
}
</script>

<style scoped>
.checkbox_align {
  padding-top: 4px;
  padding-bottom: 0px !important;
}
</style>
